import { type Tag } from '@hungryroot/rest';
import { tagGroups } from '@hungryroot/tags';

type BrandTagLookup = Pick<Tag, 'id' | 'name'> &
  Partial<Pick<Tag, 'tag_group_id'>>;

function normalizeBrandValue(value: string) {
  return value.toLowerCase().trim();
}

function findBrandTagByName(
  brandName: string,
  brandTags: BrandTagLookup[]
): BrandTagLookup | undefined {
  const normalizedBrandName = normalizeBrandValue(brandName);

  const exactMatch = brandTags.find(
    (tag) => normalizeBrandValue(tag.name) === normalizedBrandName
  );
  if (exactMatch) {
    return exactMatch;
  }

  const prefixPatterns = [
    `${normalizedBrandName} -`,
    `${normalizedBrandName} x`,
  ];

  return brandTags.find((tag) => {
    const normalizedTagName = normalizeBrandValue(tag.name);
    return prefixPatterns.some((pattern) =>
      normalizedTagName.startsWith(pattern)
    );
  });
}

export function getBrandTagId(
  brandName: string | null | undefined,
  tags: BrandTagLookup[] | undefined
): number | undefined {
  if (!brandName || !tags?.length) {
    return undefined;
  }

  const brandTags = tags.filter((tag) => tag.tag_group_id === tagGroups.brand);

  if (brandTags.length === 1) {
    return brandTags[0].id;
  }

  if (brandTags.length > 1) {
    return findBrandTagByName(brandName, brandTags)?.id;
  }

  return findBrandTagByName(brandName, tags)?.id;
}
